import script from "./exam-score-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./exam-score-chart.vue?vue&type=script&lang=ts&setup=true"

import "./exam-score-chart.vue?vue&type=style&index=0&id=939e473c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-939e473c"]])

export default __exports__